module.exports = __webpack_public_path__ + "img/login-query.63679dea.svg";